module.exports = __webpack_public_path__ + "static/media/optional-settings-black.f84030a1.svg";